import React from 'react';
import '../styles/Instrucciones.css';

//Imagenes
import logo from '../imgs/otros/juego rio-15.png';
import inicio from '../imgs/Instrucciones/inicio.jpg';
import notificaciones from '../imgs/Instrucciones/notificacion-turno.png';
import dados from '../imgs/Instrucciones/dados.jpg';
import casillaNegra from '../imgs/Instrucciones/casilla-negra.png';
import casillaAzul from '../imgs/Instrucciones/casilla-azul.png';
import casillaRoja from '../imgs/Instrucciones/casilla-roja.png';
import casillaVerde from '../imgs/Instrucciones/casilla-verde.png';
import casillaAmarilla from '../imgs/Instrucciones/casilla-amarilla.png';
import puntuaciones from '../imgs/Instrucciones/Puntuaciones.png';
import casilla50 from '../imgs/Instrucciones/casilla50.png';
import tiempoFinal from '../imgs/Instrucciones/tiempo-final.png';


export default function Instrucciones(props) {
    return (
        <div className='Instrucciones__div--container' onClick={() => props.mostrarInstruccionesFuncion(false)}>
            <div className='Instrucciones__div--panel-instrucciones'>
                <div className='Instrucciones__div--cerrar'></div>
                <div className='Instrucciones__div--container-imagen'>
                    <img className='Instrucciones__img--logo' src={logo} alt='logo.png'/>
                </div>
                <h2 className='Instrucciones__h2--instrucciones'>
                    Como jugar?
                </h2>
                <div className='Instrucciones__div--seccion'>
                    <h3>
                        Inicio
                    </h3>
                    <p>
                        Para iniciar la partida debemos presionar sobre el botón “iniciar”, posteriormente iniciara un contador de 30 minutos y se podrá comenzar a tirar el dado.
                    </p>
                    <div className='Instrucciones__div--container-imagen'>
                        <img className='Instrucciones__img Instrucciones__img--inicio' src={inicio} alt='inicio.png'/>
                    </div>
                    <h3>
                        Turno
                    </h3>
                    <p>
                    A través de notificaciones se mostrará el siguiente turno, si no lograste ver la notificación debes estar pendiente del dado que se pintará con el turno actual.
                    </p>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img  Instrucciones__img--notificaciones' src={notificaciones} alt='notificaciones.png'/>
                        </div>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--dados' src={dados} alt='dados.png'/>
                        </div>
                    </div>
                    <h3>
                        Casillas
                    </h3>
                    <div className='Instrucciones__div--container-casillas'>
                        <div className='Instrucciones__div--casilla'>
                            <img src={casillaNegra} alt='casilla-negra.png'/>
                            <p>Las casillas negras no tendrán interacciones extra.</p>
                        </div>
                        <div className='Instrucciones__div--casilla'>
                            <img src={casillaVerde} alt='casilla-verde.png'/>
                            <p>Las casillas verdes nos mostraran una pregunta la cual si se responde correctamente se subira en la escalera recortando camino además sumara un punto, si se responde erróneamente el ficho se quedará en la posición en la que esta y no se sumaran puntos. </p>
                        </div>
                        <div className='Instrucciones__div--casilla'>
                            <img src={casillaRoja} alt='casilla-roja.png'/>
                            <p>Las casillas rojas nos mostraran una pregunta la cual si se responde correctamente el ficho se mantendrá en la casilla en la que se encuentra y sumara un punto, si se responde erróneamente el ficho descenderá en el gusanito a una casilla anterior y no sumara puntos. </p>
                        </div>
                        <div className='Instrucciones__div--casilla'>
                            <img src={casillaAmarilla} alt='casilla-amarilla.png'/>
                            <p>Las casillas amarillas nos mostraran una pregunta la cual si se responde correctamente se sumará un punto y se podrá tirar el dado de nuevo teniendo un turno extra para jugar.</p>
                        </div>
                        <div className='Instrucciones__div--casilla'>
                            <img src={casillaAzul} alt='casilla-azul.png'/>
                            <p>Las casillas azules nos mostrarán pistas, estas pistas nos darán información importante relacionada a las preguntas que nos pueden salir en el juego.</p>
                        </div>
                    </div>
                    <h3>
                        Puntuaciones
                    </h3>
                    <p>
                        Tendremos un panel de puntos en el que se reflejaran los puntos que sume cada jugador.
                    </p>
                    <div className='Instrucciones__div--container-imagen'>
                        <img className='Instrucciones__img Instrucciones__img--puntuaciones' src={puntuaciones} alt='puntuaciones.png'/>
                    </div>
                    <h3>
                        Final de la partida
                    </h3>
                    <p>
                        Para finalizar el juego todos los fichos deben estar en la casilla 50 o el tiempo tiene que llegar a cero, el ganador del juego será quien más puntos haga en la partida.
                    </p>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--puntuaciones' src={casilla50} alt='puntuaciones.png'/>
                        </div>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--puntuaciones' src={tiempoFinal} alt='puntuaciones.png'/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}
